// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import { local } from 'wix-storage';
import wixLocation from 'wix-location';
import { getUserDetails } from 'public/wixUsers';
import wixWindow from 'wix-window';

// ...

let savedUserEmail
let savedUserId
let baseUrl = wixLocation.baseUrl;

$w.onReady(function () {
    //TODO: write your page related code here...
   pageEvents();

});

function pageEvents() {
    // CHECK IF IT'S A USER

    getUserDetails().then(user => {
            savedUserEmail = user.email

        })
    
        .catch((err) => {
            notUser()

            function notUser() {
                console.log("not a user");

                $w("#columnStripLightboxTrigger").onViewportEnter((event) => {
                    wixWindow.openLightbox("signUp");

                    
                }); 

                let errMsg = err.message;
                let errCode = err.code;
            }
        });
        
    // CHECK IF IT'S A USER

    $w('#searchInput').onKeyPress((e) => {
        if (e.key === "Enter") {
            handleSerch();
        }
    });

    $w('#searchButton').onClick(() => {
        handleSerch();
    });
}

function handleSerch() {
    const valueToSearch = $w('#searchInput').value;
    local.setItem('searchValue', valueToSearch);
    wixLocation.to('/results-page');
}

